/* Carrossel fluido de fotos por cor no cartão de produto (skill carrossel-fluido, aprovado no layout FENN).
 * Liga sozinho em todo elemento com data-carrossel (JSON: {cores:[{hex, nome, fotos:[urls]}]}),
 * inclusive nos cartões que o tema redesenha depois (filtros, rolagem infinita, editor de tema).
 *
 * Regras que fazem isso funcionar no iPhone (não mude sem ler a skill):
 *   - escutadores de toque PASSIVOS: nunca preventDefault, nunca pointer capture;
 *   - escutadores na MOLDURA (figure), não na faixa deslocada;
 *   - três cópias da sequência de fotos, pessoa sempre na cópia do meio;
 *   - pulo pra cópia do meio só no transitionend ou durante o arrasto;
 *   - imagens SEM pointer-events:none.
 *
 * Fenn (19/09/2026, pedido do Leonardo): dentro do modal de confirmação da cestinha
 * (#quick-add-modal-content), a foto fica ESTÁTICA - só a 1ª de cada cor, sem arrastar/setas. O
 * CARTÃO DA GRADE (home/coleção) continua um carrossel completo, sem nenhuma trava - essa trava é
 * detectada sozinha pela posição no DOM (dentro do modal ou não), não depende de nenhum atributo
 * vindo do Liquid, então nunca afeta o cartão da grade.
 */
(function (global) {
  if (global.__fennCarrosselFluido) return; // a tag do script aparece em cada cartão; só roda uma vez
  global.__fennCarrosselFluido = true;
  function iniciarCarrosselFluido(card, dados) {
    var trilho = card.querySelector('.trilho-fotos');
    var moldura = card.querySelector('figure');
    var pontos = card.querySelector('.pontos-foto');
    var corsEl = card.querySelector('.cores');
    if (!trilho || !moldura || !dados || !dados.cores || !dados.cores.length) return null;
    dados.cores = dados.cores.filter(function (c) { return c && c.fotos && c.fotos.length; });
    if (!dados.cores.length) return null;
    var nome = card.dataset.nome || '';
    var somenteCapa = !!card.closest('#quick-add-modal-content');
    // Fenn (14/09/2026, pedido do Leonardo: "não pode carregar a página na cor errada e só depois
    // trocar pra certa"): antes o carrossel sempre começava na cor 0 (a primeira cadastrada) e só
    // trocava pra cor certa DEPOIS, quando o script da página de produto (fenn-produto.js) chamava
    // trocarCor - dava pra ver o "pulo" de uma cor pra outra. Agora, quando a página já chega com uma
    // cor pré-selecionada (dados.corInicial, calculado no Liquid a partir de product.selected_variant
    // - só existe na página de produto, quando veio um ?variant= da grade; em cartão de coleção normal
    // fica sempre null e nada muda aqui), o carrossel já NASCE nela - a primeira montagem de fotos
    // (montarFotos(0) mais abaixo) já usa o índice certo, sem troca nenhuma depois.
    var corAtual = 0;
    if (dados.corInicial) {
      var indiceInicial = dados.cores.findIndex(function (c) { return c.nome === dados.corInicial; });
      if (indiceInicial >= 0) corAtual = indiceInicial;
    }
    var quadro = 0; // posição na faixa de 3 cópias: de n a 2n-1 é a cópia do meio

    function total() { return somenteCapa ? 1 : dados.cores[corAtual].fotos.length; }
    function largura() { return moldura.clientWidth || 1; }
    function indiceReal(q) { var n = total(); if (n < 2) return 0; return ((q % n) + n) % n; }
    function normalizar(q) { var n = total(); if (n < 2) return 0; while (q < n) q += n; while (q >= 2 * n) q -= n; return q; }
    function marcarPonto(indice) {
      if (!pontos) return;
      pontos.querySelectorAll('span').forEach(function (p, i) { p.classList.toggle('ativo', i === indice); });
    }
    function posicionar(q, animar, duracaoMs) {
      quadro = q;
      trilho.style.transition = animar ? 'transform ' + (duracaoMs || 320) + 'ms cubic-bezier(.22,.61,.36,1)' : 'none';
      trilho.style.transform = 'translateX(' + (-q * 100) + '%)';
      marcarPonto(indiceReal(q));
    }
    trilho.addEventListener('transitionend', function (e) {
      if (e.target !== trilho) return;
      var n = total();
      if (quadro < n || quadro >= 2 * n) posicionar(normalizar(quadro), false);
      else trilho.style.transition = 'none';
    });

    // Deixa as <img> do trilho iguais às fotos da cor atual. Devolve true se precisou RECRIAR as
    // <img> (quantidade diferente) - aí quem chamou tem que reposicionar o trilho.
    function sincronizarImgs() {
      var fotos = dados.cores[corAtual].fotos;
      if (somenteCapa) fotos = fotos.slice(0, 1);
      var n = fotos.length;
      var lista = n > 1 ? fotos.concat(fotos, fotos) : fotos.slice();
      var imgs = trilho.querySelectorAll('img');
      var recriou = false;
      if (imgs.length !== lista.length) {
        recriou = true;
        trilho.innerHTML = lista.map(function (_, i) {
          return '<img alt="' + nome.replace(/"/g, '&quot;') + '" draggable="false"' + (i === n ? '' : ' loading="lazy"') + '>';
        }).join('');
        imgs = trilho.querySelectorAll('img');
      }
      // Fenn (19/09/2026, causa do "cor não muda a foto no modal"): quando a quantidade de <img> já
      // bate (caso do modal, 1 foto só), a <img> reaproveitada é a foto de partida desenhada pelo
      // Liquid (image_tag), que vem com `srcset` - e o navegador dá preferência ao srcset sobre o
      // src. Trocar só o src deixava a foto ANTIGA na tela (o atributo src dizia "branco", a tela
      // mostrava preto). Tirar srcset/sizes antes de trocar o src.
      lista.forEach(function (src, i) {
        if (imgs[i].hasAttribute('srcset')) { imgs[i].removeAttribute('srcset'); imgs[i].removeAttribute('sizes'); }
        if (imgs[i].getAttribute('src') !== src) imgs[i].src = src;
      });
      return recriou;
    }

    function montarFotos(indiceParaManter) {
      sincronizarImgs();
      var n = total();
      // barra de fotos em TODO cartão: com 1 foto só, mostra 3 traços de reserva (toda peça vai ter
      // pelo menos 3 fotos), pra marca, nome, cor e preço ficarem na mesma altura entre cartões vizinhos
      var tracos = n > 1 ? n : 3;
      if (pontos && pontos.querySelectorAll('span').length !== tracos) {
        pontos.innerHTML = new Array(tracos + 1).join('<span></span>');
      }
      var indice = Math.min(indiceParaManter || 0, n - 1);
      posicionar(n > 1 ? n + indice : 0, false);
    }

    function montarCores() {
      if (!corsEl) return;
      corsEl.innerHTML = '';
      // hexágono de cor em TODOS os produtos, mesmo com uma cor só (pedido do Leonardo, pra organizar o layout)
      {
        dados.cores.forEach(function (c, i) {
          var btn = document.createElement('button');
          btn.type = 'button'; btn.className = 'cor' + (i === corAtual ? ' ativo' : '');
          btn.style.setProperty('--c', c.hex || '#cccccc'); btn.setAttribute('aria-label', c.nome || ('Cor ' + (i + 1)));
          // Fenn (14/09/2026): hexágono decorativo separado do botão de toque, mesma técnica de
          // "hexágonos sólidos empilhados" da página de produto (assets/fenn-produto.css .fenn-hex) -
          // border+clip-path não desenha contorno contínuo em forma de hexágono, só fragmentos retos.
          // A marcação de selecionado (classe .ativo no botão) usa um brilho (filter: drop-shadow) só
          // em CSS, sem precisar de nenhum span extra - ver o comentário em fenn-carrossel-fluido.css.
          var mini = document.createElement('span');
          mini.className = 'fenn-hex-mini';
          btn.appendChild(mini);
          btn.addEventListener('click', function (e) {
            e.preventDefault(); e.stopPropagation();
            trocarCor(i);
          });
          corsEl.appendChild(btn);
        });
      }
    }
    montarCores();
    function trocarCor(i) {
      if (!dados.cores[i]) return;
      if (i === corAtual) {
        // Mesma cor: nada a trocar, mas confere se as <img> ainda são as desta cor - o Shopify
        // pode ter redesenhado (morph) o trilho com a foto de partida do servidor por cima.
        if (!arrastando && sincronizarImgs()) posicionar(normalizar(quadro), false);
        return;
      }
      var indiceAtual = indiceReal(quadro);
      corAtual = i;
      if (corsEl) corsEl.querySelectorAll('.cor').forEach(function (x, k) { x.classList.toggle('ativo', k === i); });
      montarFotos(indiceAtual); // fotos da cor nova, na mesma posição em que a pessoa estava
      atualizarLinksDoCartao(dados.cores[i].variantId);
    }

    // Fenn (14/09/2026, pedido do Leonardo: "se eu selecionei a cor branca na grade, a página do
    // produto tem que abrir na cor branca"): o Horizon já resolve isso sozinho pro seletor de cor
    // NATIVO do tema (product-card.js #updateLinks, chamado quando o cliente marca um <input
    // type="radio"> de cor) - grava o ?variant=<id> nos 3 links do cartão (capa/moldura, título e o
    // link invisível que cobre o cartão inteiro) pra qualquer clique subsequente já abrir na variante
    // certa. Só que esse mecanismo nunca roda pro nosso hexágono (um <button>, não um <input radio>),
    // então o clique sempre levava pra variante padrão do produto, ignorando a cor escolhida no
    // cartão. Replica aqui o mesmo resultado (atualizar os 3 links), usando o ID de variante que já
    // vem pronto no JSON de cada cor (variantId, de product_option_value.variant no Liquid - a mesma
    // "primeira variante disponível, ou primeira variante" que o tema usa nativamente).
    function atualizarLinksDoCartao(variantId) {
      var pc = card.closest('product-card');
      if (!pc) return; // ex.: se este carrossel algum dia rodar fora de um cartão de produto
      ['[ref="productCardLink"]', '[ref="cardGalleryLink"]', '[ref="productTitleLink"]'].forEach(function (sel) {
        pc.querySelectorAll(sel).forEach(function (linkEl) {
          if (!linkEl.getAttribute('href')) return;
          try {
            var url = new URL(linkEl.href);
            if (variantId) url.searchParams.set('variant', variantId);
            else url.searchParams.delete('variant');
            linkEl.href = url.toString();
          } catch (e) {}
        });
      });
    }
    montarFotos(0);
    // A cor corAtual já nasce "ativa" (ver a marcação no próprio botão, acima); garante que os links
    // do cartão já apontem pra ela desde o carregamento, sem precisar de nenhum clique primeiro.
    atualizarLinksDoCartao(dados.cores[corAtual] && dados.cores[corAtual].variantId);

    var arrastando = false, x0 = 0, dx = 0, amostras = [];
    function comecar(x) {
      if (total() < 2) return;
      arrastando = true; x0 = x; dx = 0; amostras = [{ t: Date.now(), x: x }];
      card.dataset.arrastou = '0';
      trilho.style.transition = 'none';
      var m = getComputedStyle(trilho).transform, w = largura();
      if (m && m !== 'none') {
        var tx = parseFloat(m.split(',')[4]) || 0, q = Math.round(-tx / w);
        quadro = q; dx = 0; x0 = x - (tx + q * w);
      }
    }
    function mover(x) {
      if (!arrastando) return;
      var w = largura(), n = total();
      dx = x - x0;
      amostras.push({ t: Date.now(), x: x }); if (amostras.length > 6) amostras.shift();
      while (dx <= -w) { quadro++; x0 -= w; dx += w; }
      while (dx >= w) { quadro--; x0 += w; dx -= w; }
      if (quadro < n || quadro >= 2 * n) quadro = normalizar(quadro);
      if (Math.abs(x - amostras[0].x) > 5) card.dataset.arrastou = '1';
      trilho.style.transform = 'translateX(calc(' + (-quadro * 100) + '% + ' + dx + 'px))';
      marcarPonto(indiceReal(quadro));
    }
    function soltar() {
      if (!arrastando) return;
      arrastando = false;
      var w = largura(), n = total();
      var a = amostras[0], b = amostras[amostras.length - 1];
      for (var i = amostras.length - 1; i >= 0; i--) { if (b.t - amostras[i].t >= 60) { a = amostras[i]; break; } }
      var veloc = (b.t - a.t) > 0 ? (b.x - a.x) / (b.t - a.t) : 0;
      var peteleco = Math.abs(veloc) > 0.35;
      var inercia = peteleco ? Math.abs(veloc) * 120 : 0;
      var sentido = dx !== 0 ? (dx < 0 ? 1 : -1) : (veloc < 0 ? 1 : -1);
      var distancia = Math.abs(dx) + inercia;
      var passos = 0;
      if (peteleco || Math.abs(dx) > 0.2 * w) passos = 1 + Math.floor(Math.max(0, distancia - w) / w);
      passos = Math.min(passos, Math.max(1, n - 1)) * sentido;
      var duracao = Math.min(900, 320 + 140 * Math.max(0, Math.abs(passos) - 1));
      posicionar(quadro + passos, true, duracao);
      if (card.dataset.arrastou === '1') setTimeout(function () { card.dataset.arrastou = '0'; }, 350);
    }
    if (!somenteCapa) {
      moldura.addEventListener('touchstart', function (e) { comecar(e.touches[0].clientX); }, { passive: true });
      moldura.addEventListener('touchmove', function (e) { mover(e.touches[0].clientX); }, { passive: true });
      moldura.addEventListener('touchend', soltar, { passive: true });
      moldura.addEventListener('touchcancel', soltar, { passive: true });
      moldura.addEventListener('mousedown', function (e) {
        if (e.button !== 0) return;
        e.preventDefault(); comecar(e.clientX);
        function m(ev) { mover(ev.clientX); }
        function fim() { window.removeEventListener('mousemove', m); window.removeEventListener('mouseup', fim); soltar(); }
        window.addEventListener('mousemove', m); window.addEventListener('mouseup', fim);
      });
    }

    // Arrasto não pode virar clique (o tema navega pro produto em qualquer clique no cartão).
    // Só barra cliques que caem na foto; botões de cor e quick add continuam livres.
    card.addEventListener('click', function (e) {
      if (card.dataset.arrastou === '1' && moldura.contains(e.target)) {
        e.preventDefault(); e.stopImmediatePropagation(); card.dataset.arrastou = '0';
      }
    }, true);

    // Setas (só existem quando o snippet foi chamado com setas:true, hoje só na página do produto).
    var setaEsq = moldura.querySelector('.seta-esq'), setaDir = moldura.querySelector('.seta-dir');
    if (setaEsq) setaEsq.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); if (total() > 1) posicionar(quadro - 1, true, 320); });
    if (setaDir) setaDir.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); if (total() > 1) posicionar(quadro + 1, true, 320); });

    // Ganchos usados pela página de produto (assets/fenn-produto.js): lá a cor é escolhida pelo
    // seletor de variante nativo do tema (pra manter preço/disponibilidade/carrinho funcionando), não
    // pelos hexágonos deste componente (que aqui nem existem, mostrar_cores:false) - então o próprio
    // fenn-produto.js chama isto quando o rádio da cor muda, pra trocar a foto igual ao cartão.
    card._fennTrocarCor = trocarCor;
    card._fennTotalFotos = total;

    // Fenn (19/09/2026, bug do vídeo do Leonardo: "clico na cor e aparecem sempre as mesmas fotos,
    // tem que ser a foto do produto em questão"): a janela de confirmação da cestinha é UMA SÓ pra
    // loja inteira - a cada produto o Shopify faz "morph" do conteúdo, ou seja, REAPROVEITA este
    // mesmo elemento e só troca os atributos (data-carrossel, data-nome) e os filhos. Como `dados`
    // ficava guardado aqui dentro desde a 1ª montagem, a janela do 2º produto em diante trocava de
    // cor usando as fotos do PRIMEIRO produto aberto. Agora iniciarTodos() compara o JSON do
    // atributo com o que foi usado na montagem (card._fennJson) e, se mudou, chama isto: mesmos
    // escutadores, dados novos, cor inicial nova, fotos e botões refeitos. Avisa quem usa o
    // carrossel de fora (fenn-produto.js) por um evento, pra sincronizar com o rádio de cor marcado.
    card._fennJson = card.getAttribute('data-carrossel');
    card._fennAtualizarDados = function (novos) {
      if (!novos || !novos.cores) return false;
      var cores = novos.cores.filter(function (c) { return c && c.fotos && c.fotos.length; });
      if (!cores.length) return false;
      // Se o morph trocou os NÓS internos (não só atributos), os escutadores de toque ficaram nos
      // nós velhos: aí só uma montagem nova resolve (quem chamou refaz do zero).
      if (!card.contains(trilho) || !card.contains(moldura)) return false;
      novos.cores = cores;
      dados = novos;
      nome = card.dataset.nome || '';
      corAtual = 0;
      if (dados.corInicial) {
        var ini = dados.cores.findIndex(function (c) { return c.nome === dados.corInicial; });
        if (ini >= 0) corAtual = ini;
      }
      arrastando = false;
      montarCores();
      montarFotos(0);
      atualizarLinksDoCartao(dados.cores[corAtual] && dados.cores[corAtual].variantId);
      card.dispatchEvent(new CustomEvent('fenn:carrossel-dados', { bubbles: true }));
      return true;
    };
    return true;
  }

  function iniciarTodos(raiz) {
    (raiz || document).querySelectorAll('[data-carrossel]').forEach(function (card) {
      // Já montado (propriedade JS no próprio nó: sobrevive ao morph do Shopify, que pode apagar o
      // atributo data-carrossel-pronto por ele não existir no HTML do servidor)? Então só confere
      // se o produto mudou por baixo - ver card._fennAtualizarDados.
      if (card._fennAtualizarDados) {
        var json = card.getAttribute('data-carrossel');
        if (json === card._fennJson) return;
        var deuCerto = false;
        try { deuCerto = card._fennAtualizarDados(JSON.parse(json)); } catch (e) { if (window.console) console.error('[fenn-carrossel]', e, card); }
        if (deuCerto) { card._fennJson = json; return; }
        // não deu pra atualizar no lugar: monta do zero logo abaixo
        card._fennAtualizarDados = null;
        delete card.dataset.carrosselPronto;
      }
      if (card.dataset.carrosselPronto) return;
      try {
        var dados = JSON.parse(card.getAttribute('data-carrossel'));
        if (iniciarCarrosselFluido(card, dados)) card.dataset.carrosselPronto = '1';
      } catch (e) {
        // JSON inválido ou erro no carrossel: fica a foto de partida desenhada pelo Shopify
        card.dataset.carrosselPronto = 'erro';
        if (window.console) console.error('[fenn-carrossel]', e, card);
      }
    });
  }

  global.iniciarCarrosselFluido = iniciarCarrosselFluido;
  global.iniciarCarrosseisFluidos = iniciarTodos;

  function ligar() {
    iniciarTodos();
    // Cartões que o tema desenha depois (filtros, "carregar mais", editor de tema)
    var obs = new MutationObserver(function (muts) {
      var precisa = false;
      for (var i = 0; i < muts.length && !precisa; i++) {
        // atributo data-carrossel trocado num elemento que já existia (morph da janela da cestinha)
        if (muts[i].type === 'attributes') { precisa = true; break; }
        var add = muts[i].addedNodes;
        for (var j = 0; j < add.length; j++) {
          var n = add[j];
          if (n.nodeType === 1 && (n.hasAttribute('data-carrossel') || n.querySelector('[data-carrossel]'))) { precisa = true; break; }
        }
      }
      if (precisa) iniciarTodos();
    });
    obs.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-carrossel'] });
    document.addEventListener('shopify:section:load', function () { iniciarTodos(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ligar);
  else ligar();
})(window);
